import { Link } from "react-router-dom";
import MovieCard from "@/components/base/MovieCard";
import { mediaList } from "@/mocks/movies";

export default function FeaturedGrid() {
  const latest = [...mediaList]
    .sort((a, b) => b.year - a.year || b.heat - a.heat)
    .slice(0, 8);

  return (
    <section className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16" aria-label="最新上线影视">
      <div className="mb-7 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-[11px] uppercase tracking-[0.3em] text-primary-600">New arrivals</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[30px]">
            最新上线
          </h2>
          <p className="mt-2 text-sm text-foreground-500">近期整理入库的影视资源，按上线年份排序。</p>
        </div>
        <div className="flex items-center gap-2">
          <Link
            to="/category/movie"
            className="inline-flex h-9 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            电影专区
            <i className="ri-arrow-right-up-line" />
          </Link>
          <Link
            to="/category/tv"
            className="inline-flex h-9 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            剧集专区
            <i className="ri-arrow-right-up-line" />
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-x-3 gap-y-7 sm:grid-cols-3 md:gap-x-5 md:gap-y-9 lg:grid-cols-4">
        {latest.map((item) => (
          <MovieCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}